import React, { useState } from 'react';
import ModalComponent from './modal.component';
import { ModalContext } from './modal.context';
import { ModalProviderProps, ModalState, ShowModal } from './types';

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  const [modalState, setModalState] = useState<ModalState>({
    title: '',
    description: '',
    actionButton: '',
    maxWidth: undefined,
    disableBackdropClick: false,
  });
  const [modalData, setModalData] = useState<Record<string, any>>({});

  const showModal: ShowModal = ({
    title,
    description,
    actionButton,
    maxWidth,
    hideCrossIcon,
    disableBackdropClick,
    initialData,
    descriptionClassName,
    className,
    modalSx,
  }) => {
    setModalState({
      title,
      description,
      actionButton,
      maxWidth,
      hideCrossIcon,
      disableBackdropClick,
      descriptionClassName,
      className,
      modalSx,
    });
    setOpen(true);
    if (initialData) {
      setModalData(initialData);
    }
  };

  const hideModal = () => {
    setOpen(false);
  };

  return (
    <ModalContext.Provider
      value={{ showModal, hideModal, setModalData, modalData }}
    >
      {children}
      <ModalComponent
        {...modalState}
        open={open}
        handleClose={
          modalState.disableBackdropClick
            ? () => {
                return;
              }
            : hideModal
        }
      />
    </ModalContext.Provider>
  );
};
